import { Routes, Route } from "react-router-dom";
import RenderPage from "../pages/Render/renderPage";
import Products from "../pages/ProductGallery/Product";
import CastingProcess from "../pages/CastingProcess/CastingProcess";
import ImageGallery from "../pages/ImageGallery/ImageGallery";
import PrivacyPolicy from "../pages/Privacy/PrivacyPolicy";

const AppRoutes = () => {
  return (
    <Routes>
      {/* LANDING + PARALLAX */}
      <Route path="/" element={<RenderPage mode="default" />} />

      {/* LEARN MORE MODE */}
      <Route path="/learn" element={<RenderPage mode="learn" />} />

      {/* REAL PAGES */}
      <Route path="/products" element={<Products />} />
      <Route path="/ImageGallery" element={<ImageGallery />} />
      <Route path="/ourProcess" element={<CastingProcess />} />

      {/* LEGAL */}
      <Route path="/privacy" element={<PrivacyPolicy />} />
    </Routes>
  );
};

export default AppRoutes;
